/*
 * AUTO-GENERATED, DO NOT EDIT
 */
import React from 'react';
function ChevronLeftIcon(props, svgRef) {
    return (React.createElement("svg", Object.assign({ "data-sanity-icon": "chevron-left", width: "1em", height: "1em", viewBox: "0 0 25 25", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: svgRef }, props),
        React.createElement("path", { d: "M15 17L9.5 12.5L15 8", stroke: "currentColor", strokeWidth: 1.2 })));
}
const ForwardRef = React.forwardRef(ChevronLeftIcon);
export default ForwardRef;
//# sourceMappingURL=chevronLeftIcon.js.map